var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Not Found")]),_c('router-link',{staticClass:"button",attrs:{"to":"/app"}},[_vm._v("Return to App")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }